export default {
    data() {
        return {
            lastKeyPressed: 0,
            permissionToCheck: ''
        };
    },
    methods: {
        setPermissionToCheck(permissionName) {
            this.permissionToCheck = permissionName;
        },
        showBlockedMessage() {
            this.tocaMusica(this.erro);
            return this.$Simplert.open({
                title: "Ação não permitida!",
                message: "Não é permitido digitar, colar ou arrastar a informação. Por favor utilize o coletor.",
                customCloseBtnText: "Fechar",
                type: "warning",
                onClose: () => {
                    this.cd_barra = "";
                }
            });
        },
        handleWritingBarcodePermission(newValue, oldValue = null) {
            if (!this.permissionToCheck) return;

            const hasUserPermission = this.getPermissionFw(this.permissionToCheck);
            if (hasUserPermission) {
                if (newValue && typeof newValue.type === 'string' && newValue.type === 'dragover') {
                    newValue.preventDefault();
                    newValue.stopPropagation();
                }
                if (newValue && typeof newValue.type === 'string' && newValue.type === 'drop') {
                    newValue.preventDefault();
                    newValue.stopPropagation();
                }
                return;
            }

            if (newValue && typeof newValue.preventDefault === 'function') {
                newValue.preventDefault();
                this.$nextTick(() => {
                    this.cd_barra = "";
                });
                return this.showBlockedMessage();
            }

            if (newValue === '') return;

            const currentDateTime = new Date().getTime();
            const timeInterval = currentDateTime - this.lastKeyPressed;
            const barCodeLength = oldValue.length;

            if (barCodeLength > 1 && timeInterval > 100) {
                this.$nextTick(() => {
                    this.cd_barra = "";
                });
                return this.showBlockedMessage();
            }
            this.lastKeyPressed = currentDateTime;
        }
    }
};